<div class="dc-modal">
  <div class="dc-modal-container">
    <button class="modal-x-button" type="button" (click)="onSubmit.emit(false)">
      <i class="fas fa-close"></i>
    </button>
    <!-- Letter Header -->
    <div class="mb-6 text-sm leading-relaxed text-dc-navy">
      <div class="space-y-1">
        <p class="font-semibold">
          {{ "ATA_CARNET.LETTER_HEADER_TO" | translate }}
        </p>
        <p>{{ "ATA_CARNET.LETTER_HEADER_DIRECTOR" | translate }}</p>
        <p>{{ "ATA_CARNET.LETTER_HEADER_DEPARTMENT" | translate }}</p>
        <p>{{ "ATA_CARNET.LETTER_HEADER_ORGANIZATION" | translate }}</p>
        <p>{{ "ATA_CARNET.LETTER_HEADER_ADDRESS" | translate }}</p>
        <p>{{ "ATA_CARNET.LETTER_HEADER_COUNTRY" | translate }}</p>
      </div>
      <p class="mt-4 text-dc-navy">
        <span class="font-semibold">{{
          "ATA_CARNET.LETTER_HEADER_DATE" | translate
        }}</span
        >&nbsp;{{ today | date : "dd/MM/yyyy" }}
      </p>
    </div>
    <div [innerHTML]="termContent"></div>
    <!-- Checkbox -->
    <div class="items-start gap-2 mb-2">
      <div class="field-control">
        <label
          class="flex items-center gap-5 lg:gap-x-2 cursor-pointer relative mt-4"
        >
          <input
            [(ngModel)]="isAccepted"
            (ngModelChange)="onAcceptTermsChange($event)"
            type="checkbox"
            class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
          />
          <span
            class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy"
          >
            <i class="fas fa-check"></i>
          </span>
          <span class="text-dc-navy leading-6">
            {{ "ATA_CARNET.LETTER_TERMS_PREFIX" | translate }}&nbsp;
            {{ "ATA_CARNET.LETTER_TERMS_LINK" | translate }}
            {{ "ATA_CARNET.LETTER_TERMS_SUFFIX" | translate }}
          </span>
        </label>
         @if (showTermsError) {
          <p class="mb-4 text-sm text-red-600!">
            {{ "ATA_CARNET.LETTER_TERMS_REQUIRED" | translate }}
          </p>
          }
        <!-- <input
        id="acceptTerms"
        type="checkbox"
        [(ngModel)]="isAccepted"
        (ngModelChange)="onAcceptTermsChange($event)"
        class="mt-1 h-4 w-4 border-gray-400 rounded"
      />
      <label for="acceptTerms" class="text-sm leading-6 text-dc-navy">
        {{ "ATA_CARNET.LETTER_TERMS_PREFIX" | translate }}&nbsp;
        {{ "ATA_CARNET.LETTER_TERMS_LINK" | translate }}
        {{ "ATA_CARNET.LETTER_TERMS_SUFFIX" | translate }}
      </label> -->
      </div>
     
      <!-- Confirm Button -->
      <div class="flex mt-4 justify-end">
        <app-button
          type="button"
          classesName="btn-edge-cut"
          [label]="'BUTTONS.OK' | translate"
          (onBtnClick)="submitPledge()"
        ></app-button>
      </div>
    </div>
  </div>
</div>
